<template>
	<div>
		<b-modal ref="modalError"
			hide-footer
			:title="$t('Errors.error')">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>

		<b-modal ref="loaderModal"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Button.loader')">
			<throbber />
			<p class="my-4">{{ $t('Tooltip.message_wait') }}</p>
		</b-modal>

		<b-modal :size="'lg'"
			ref="previewModal"
			static="true"
			:lazy=true
			ok-only>
			<div class="embed-responsive embed-responsive-16by9">
				<video class="embed-responsive-item"
					:src="preview_path"
					ref="playerpreview"
					controls
					height="600"
					width="800"></video>
			</div>
		</b-modal>

		<div class="row">
			<div class="col-12 col-lg-6 mt-4">
				<form>
					<div class="form-group" v-if="hasTitleField">
						<label class="title_label keyText"
							for="title">{{ $t('Detail.title') }}</label>
						<span class="modificationLabel"> {{ this.modificationTitle }} </span> <input type="text"
						class="form-control no-border"
						:class="[ inputValue.length >=50 ? 'warning' : '' ]"
						id="title"
						@change="setModificationTitleLabel()"
						@input="setModificationTitleLabel()"
						v-model="inputValue">
					</div>
				</form>
			</div>
		</div>
		<div class="row" v-if="hasContentField">
			<div class="col-12 col-lg-6 mt-4">
				<label for="textarea-auto-height" class="title_label keyText">{{ $t('Detail.content') }}</label>
				<span class="modificationLabel"> {{ this.modificationContent }} </span>
				<p class="title_label keyText" style="margin-bottom: 0">{{ $t('Detail.subContent') }}</p>
				<b-form-textarea
					class="detail-area"
					:class="[ inputContentValue.length >=250 || (inputContentValue.match(/\n/g) || []).length >= 5 ? 'warning' : '' ]"
					id="textarea-auto-height"
					rows="7"
					max-rows="7"
					no-auto-shrink="true"
					scrolling="yes"
					@change="setModificationContentLabel()"
					@input="setModificationContentLabel()"
					v-model="inputContentValue">
				</b-form-textarea>
			</div>
		</div>
		<div class="row">
			<div class="form-group volume">
				<label><input type="checkbox" name="mute" v-model="hasMusicEnable"
					@input="setModified" /> {{ $t("Button.enable_music") }}</label>
				<span class="modificationLabel">{{ this.modification_mute }}</span><br />
				<label>Volume : {{ music_volume }}%<br /><input :disabled="!hasMusicEnable" @change="setModified" type="range" id="music_volume" name="music_volume"
					min="10" max="100" step="10" v-model="music_volume"></label>
			</div>
		</div>
		<b-row>
			<b-col md="auto">
				<valid-step :id="this.id"
					:value="this.inputValue"
					:content-value="this.inputContentValue"
					:music_enabled="hasMusicEnable"
					:music_volume="music_volume"
					:disabled="!modified">
				</valid-step>
			</b-col>
			<b-col md="auto" style="padding-left: 0;">
				<div class="mt-4">
					<button
						class="btn btn-preview"
						:disabled="!isCompleted || modified"
						@click="preview"
					>{{ $t("Button.preview") }}
					</button>
				</div>
			</b-col>
			<b-col md="auto" style="padding-left: 0;">
				<div class="mt-4">
					<a href="#"
						class="btn btn-cancel"
						@click="reset_modified"
						:class="[modified ? '' : 'disabled']">{{ $t("Button.modifications") }}</a>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import ValidStep from "../ui/buttons/ValidStepDetail";
import axios from "axios";
import {EventBus} from "../../event/event-bus";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Detail",
	components: {
		ValidStep,
		throbber,
		lottie_error,
	},
	props: {
		id: Number,
		stepName: String,
		translationId: String,
		title: String,
		hasTitleField: Boolean,
		secondaryTitle: String,
		hasSecondaryTitle: Boolean,
		textes: String,
		hasTextesField: Boolean,
		content: String,
		hasContentField: Boolean,
		hasVoiceOver: Boolean,
		projectId: Number,
		groupId: String,
		renderId: String,
		stepIndex: Number,
		isCompleted: String,
		isVisible: Boolean,
		created_at: String,
		updated_at: String,
	},
	data() {
		return {
			value: "",
			contentValue: "",
			text_error: "",
			modificationTitle: "",
			modificationContent: "",
			modified: false,
			preview_path: "",
			hasMusicEnable: false,
			music_volume: 100,
			modification_mute: "",
		};
	},
	computed: {
		inputValue: {
			get() {
				return this.value;
			},
			set(v) {
				this.value = v;
			},
		},
		inputContentValue: {
			get() {
				return this.contentValue;
			},
			set(v) {
				this.contentValue = v;
			},
		},
	},
	created() {
		let $this = this;
		EventBus.$on("setModificationTitleLabel", label => {
			this.modified = false;
			$this.modificationTitle = label;
		});
		EventBus.$on("setModificationContentLabel", label => {
			this.modified = false;
			$this.modificationContent = label;
		});
		EventBus.$on("setModified", bool => {
			if (bool) {
			}
			else {
				this.reset_modified();
			}
		});
	},
	deactivated() {
		EventBus.$off("setLanguage");
	},
	activated() {
		this.getDatas();
	},
	methods: {
		getDatas() {
			let $this = this;
			axios.get(BASE_URL + "/public/api/stepDetails/" + $this.id, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				let data = response.data.data;

				$this.hasMusicEnable = data.hasMusicEnable;
				$this.music_volume = data.music_volume;

				if (data.title === null) {
					$this.inputValue = "";
				}
				else {
					$this.inputValue = data.title;
				}
				if (data.content === null) {
					$this.inputContentValue = "";
				}
				else {
					$this.inputContentValue = data.content;
				}
			}).catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
		setModificationTitleLabel() {
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepDetail"});
			this.modified = true;
			this.modificationTitle = this.$root.$t("Button.editing");
		},
		setModificationContentLabel() {
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepDetail"});
			this.modified = true;
			this.modificationContent = this.$root.$t("Button.editing");
		},
		setModified() {
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepDetail"});
			this.modified = true;
			this.modification_mute = this.$root.$t("Button.editing");
		},
		preview() {
			this.$refs.loaderModal.show();

			axios.get(BASE_URL + "/public/api/stepDetails/" + this.id + "/preview",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				let data = response.data;

				this.$refs.loaderModal.hide();

				this.preview_path = BASE_URL + "/public/storage/videos/generated/" + data.url + "#" + new Date().getTime();
				this.$refs.previewModal.show();
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		reset_modified() {
			this.getDatas();
			EventBus.$emit("unlock_steps", {id: this.id, type: "App\\StepDetail"});
			this.modified = false;
			this.modification_mute = "";
			this.modificationTitle = "";
			this.modificationContent = "";
		},
	},
};
</script>

<style scoped>
input {
	border-radius: 0;
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #007DBF solid 1px;
}

.detail-area {
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #007DBF solid 1px;
	-webkit-border-radius: 0;
	-moz-border-radius: 0;
	border-radius: 0;
}

.btn {
	border-radius: var(--small-border-radius);
}

.btn-info {
	background-color: var(--color-secondary-action);
	border-color: var(--color-secondary-action);
	color: var(--text-secondary-action);
}

.btn-preview {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-secondary-action);
}

.modificationLabel {
	font-size: 14px;
	color: orange;
}

.btn-cancel {
	background-color: var(--color-modification);
	border-color: var(--color-modification);
	color: var(--text-modification);
}

input.warning,
textarea.warning {
	color: red;
}

.volume {
	padding: 20px 20px 0;
}

</style>
